module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "toc"
    }
  }), _c('a', {
    attrs: {
      "id": "page_XI"
    }
  }, [_c('h2', {
    staticClass: "title3"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTENTS")])])]), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_XI"
    }
  }), _c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_c('i', [_vm._v("First Chapter")]), _c('br'), _vm._v("A strange meeting takes place on a lotus lake; Judge Dee is attacked on his way to Lan-fang")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chap2"
    }
  }, [_c('i', [_vm._v("Second Chapter")]), _c('br'), _vm._v("Judge Dee opens the first session of the tribunal; He discovers in the archives an unsolved problem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Third Chapter")]), _c('br'), _vm._v("The judge witnesses a quarrel on the market; A young man forecasts his father’s murder")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Fourth Chapter")]), _c('br'), _vm._v("Tao Gan reports on a mysterious old mansion; An ingenious trap is set in the dark tribunal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Fifth Chapter")]), _c('br'), _vm._v("Twenty ruffians attack in the dead of night; Judge Dee sets out on a dangerous excursion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Sixth Chapter")]), _c('br'), _vm._v("Four guildmasters are received in the main hall; Mrs. Yoo visits the tribunal with an old picture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Seventh Chapter")]), _c('br'), _vm._v("Three roguish monks receive their just punishment; A Candidate of Literature reports a cruel murder")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_XII"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Eighth Chapter")]), _c('br'), _vm._v("An old General is murdered in his own library; Judge Dee goes to visit the scene of the crime")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Ninth Chapter")]), _c('br'), _vm._v("Judge Dee ponders alone in a dead man’s room; The autopsy brings to light the cause of death")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Tenth Chapter")]), _c('br'), _vm._v("Judge Dee pays a visit to an eccentric young man; He presides an artistic meeting in the tribunal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Eleventh Chapter")]), _c('br'), _vm._v("Tao Gan has an adventure in an old temple; Ma Joong meets his match in a drinking bout")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Twelfth Chapter")]), _c('br'), _vm._v("Judge Dee discusses the secrets of two pictures; A young girl discovers passionate love letters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Thirteenth Chapter")]), _c('br'), _vm._v("Yoo Kee entertains a distinguished guest to tea; Judge Dee decides to revisit the General’s studio")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Fourteenth Chapter")]), _c('br'), _vm._v("A strange clue is found in a dead man’s room; Judge Dee sends his men to arrest a criminal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Fifteenth Chapter")]), _c('br'), _vm._v("Painter Woo reveals his secret in the tribunal; Judge Dee orders a search of the Eastern city")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap16",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Sixteenth Chapter")]), _c('br'), _vm._v("Ma Joong investigates the licensed quarter; He is made a partner in a nefarious scheme")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_XIII"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap17",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Seventeenth Chapter")]), _c('br'), _vm._v("Mrs. Yoo pays a second visit to the tribunal; A queer discovery is made in an old mansion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap18",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Eighteenth Chapter")]), _c('br'), _vm._v("Judge Dee decides to consult an old hermit; Ma Joong catches his man in the Drum Tower")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap19",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Nineteenth Chapter")]), _c('br'), _vm._v("A recluse discourses on the purpose of life; Judge Dee learns the old Governor’s secret")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap20",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Twentieth Chapter")]), _c('br'), _c('i', [_vm._v("A")]), _vm._v(" rebel chieftain confesses under torture; A mysterious stranger is at last identified")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap21",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Twenty first Chapter")]), _c('br'), _vm._v("Judge Dee closes the case of the murdered General; Chiao Tai relates the story of a military disaster")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap22",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Twenty second Chapter")]), _c('br'), _vm._v("Judge Dee explains the murder of General Ding; He reveals the secret of the scroll picture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap23",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Twenty third Chapter")]), _c('br'), _vm._v("The judge leads his men to the heart of the maze; A gruesome discovery is made in a secret pavilion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap24",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Twenty fourth Chapter")]), _c('br'), _c('i', [_vm._v("A")]), _vm._v(" young girl goes to visit a famous artist; A criminal is caught in an unexpected place")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap25",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Twenty fifth Chapter")]), _c('br'), _vm._v("Two depraved criminals suffer the extreme penalty; Judge Dee learns the secret of an abstruse couplet")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b833b32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 75
// module chunks = 0